<template>
    <MainLayout>
        <LoaderPage v-if="loadingPage" />
        <div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="md:tw-sticky md:tw-top-[65px] tw-z-10">
            <div class="tw-mx-auto tw-px-6 tw-py-4 tw-flex tw-justify-between tw-items-center">
                <div>
                    <h1 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-800'" class="tw-text-2xl tw-font-bold">Configurações de Aeração</h1>
                </div>
                <div class="tw-flex tw-items-center tw-gap-4">
                    <span v-if="!permissaoEditar" :class="theme === 'dark' ? 'tw-bg-amber-500/10 tw-text-amber-400 tw-border-amber-500/20' : 'tw-bg-amber-50 tw-text-amber-700 tw-border-amber-200'" class="tw-px-4 tw-py-1.5 tw-rounded-full tw-border">
                        Modo Visualização
                    </span>
                </div>
            </div>
        </div>
        <main :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-mx-auto tw-p-6">
            <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-6">
                <div class="lg:tw-col-span-7 tw-space-y-6">
                    <section :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-rounded-2xl tw-p-6 tw-shadow-sm">
                        <div class="tw-flex tw-items-center tw-gap-3 tw-mb-8">
                            <div class="tw-p-2.5 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-blue-500/10 tw-text-blue-400' : 'tw-bg-blue-50 tw-text-blue-600'">
                                <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
                            </div>
                            <div>
                                <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Energia e Custos</h3>
                            </div>
                        </div>

                        <div class="tw-space-y-6">
                            <div :class="theme === 'dark' ? 'tw-flex tw-items-center tw-justify-between tw-p-5 tw-bg-blue-500/10 tw-rounded-2xl' : 'tw-flex tw-items-center tw-justify-between tw-p-5 tw-bg-blue-100 tw-rounded-2xl'">
                                <div class="tw-flex tw-gap-4 tw-items-center">
                                    <div :class="theme === 'dark' ? 'tw-bg-blue-400' : 'tw-bg-blue-500'" class="tw-w-2 tw-h-10 tw-rounded-full"></div>
                                    <div>
                                        <p :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-sm tw-font-bold">Horário de Ponta</p>
                                        <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs">Suspender aeração durante o período de maior tarifa</p>
                                    </div>
                                </div>
                                <label class="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer">
                                    <input type="checkbox" v-model="parametros_configuracoes['horario_ponta']" true-value="ativo" false-value="inativo" :disabled="!permissaoEditar" class="tw-sr-only tw-peer">
                                    <div :class="theme === 'dark' ? 'tw-w-12 tw-h-6 tw-bg-slate-700 tw-rounded-full tw-peer peer-checked:tw-bg-blue-500' : 'tw-w-12 tw-h-6 tw-bg-gray-300 tw-rounded-full tw-peer peer-checked:tw-bg-blue-600'" class="after:tw-content-[''] after:tw-absolute after:tw-top-[2px] after:tw-left-[2px] after:tw-bg-white after:tw-border after:tw-rounded-full after:tw-h-5 after:tw-w-5 peer-checked:after:tw-translate-x-6"></div>
                                </label>
                            </div>

                            <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4 sm:tw-gap-6">
                                <div class="tw-space-y-2">
                                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Início do Período</label>
                                    <input type="time" v-model="parametros_configuracoes['horario_ponta_inicio']" :disabled="!permissaoEditar" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white relogio-dark' : 'tw-bg-gray-300 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-blue-500">
                                </div>
                                <div class="tw-space-y-2">
                                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Término do Período</label>
                                    <input type="time" v-model="parametros_configuracoes['horario_ponta_termino']" :disabled="!permissaoEditar" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white relogio-dark' : 'tw-bg-gray-300 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-blue-500">
                                </div>
                            </div>

                            <hr :class="theme === 'dark' ? 'tw-border-slate-700' : 'tw-border-slate-200'" />

                            <div class="tw-space-y-4">
                                <div class="tw-flex tw-items-center tw-justify-between">
                                    <h4 :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-sm tw-font-bold">Controle de Demanda</h4>
                                    <label class="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer">
                                        <input type="checkbox" v-model="parametros_configuracoes['demanda']" true-value="ativo" false-value="inativo" :disabled="!permissaoEditar" class="tw-sr-only tw-peer">
                                        <div :class="theme === 'dark' ? 'tw-w-12 tw-h-6 tw-bg-slate-700 tw-rounded-full tw-peer peer-checked:tw-bg-blue-500' : 'tw-w-12 tw-h-6 tw-bg-gray-300 tw-rounded-full tw-peer peer-checked:tw-bg-blue-600'" class="after:tw-content-[''] after:tw-absolute after:tw-top-[2px] after:tw-left-[2px] after:tw-bg-white after:tw-rounded-full after:tw-h-5 after:tw-w-5 peer-checked:after:tw-translate-x-6"></div>
                                    </label>
                                </div>
                                <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4 sm:tw-gap-6">
                                    <div class="tw-relative">
                                        <span :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-absolute tw-left-4 tw-top-1/2 -tw-translate-y-1/2 tw-text-xs tw-font-bold">LIMITE</span>
                                        <input type="number" v-model="parametros_configuracoes['aeracao_demanda_kw']" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-300 tw-text-black'" class="tw-w-full tw-pl-16 tw-pr-12 tw-py-3 tw-rounded-xl tw-text-sm focus:tw-ring-2 focus:tw-ring-blue-500">
                                        <span :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-absolute tw-right-4 tw-top-1/2 -tw-translate-y-1/2 tw-text-xs tw-font-bold">kW</span>
                                    </div>
                                    <div class="tw-relative">
                                        <span :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-text-xs tw-font-bold tw-left-4">CUSTO</span>
                                        <input type="number" step="any" v-model="parametros_configuracoes['aeracao_custo_kw']" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-300 tw-text-black'" class="tw-w-full tw-pl-[92px] tw-pr-14 tw-py-3 tw-rounded-xl tw-text-sm focus:tw-ring-2 focus:tw-ring-blue-500">
                                        <span :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-absolute tw-left-[66px] tw-top-1/2 -tw-translate-y-1/2 tw-text-xs tw-font-bold">R$</span>
                                        <span :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-absolute tw-right-4 tw-top-1/2 -tw-translate-y-1/2 tw-text-xs tw-font-bold">kW/h</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="lg:tw-col-span-5 tw-space-y-6">
                    <section :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-rounded-2xl tw-p-6 tw-shadow-sm">
                        <div class="tw-flex tw-items-center tw-gap-3 tw-mb-8">
                            <div class="tw-p-2.5 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-600'">
                                <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"/></svg>
                            </div>
                            <div>
                                <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Clima e Proteção</h3>
                            </div>
                        </div>
                        <div class="tw-space-y-3">
                            <div v-for="(label, key) in {
                                'aeracao_chuva': 'Permitir Aeração com Chuva',
                                'aeracao_termometria': 'Aerar durante Termometria',
                                'intervalo_pos_chuva': 'Ativar Intervalo pós Chuva'
                                }" :key="key" :class="theme === 'dark' ? 'tw-flex tw-items-center tw-justify-between tw-p-4 tw-rounded-xl hover:tw-bg-[#1a1d21]' : 'tw-flex tw-items-center tw-justify-between tw-p-4 tw-rounded-xl hover:tw-bg-slate-50'">
                                <span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-600'" class="tw-text-sm tw-font-medium">{{ label }}</span>
                                <label class="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer">
                                    <input type="checkbox" v-model="parametros_configuracoes[key]" true-value="ativo" false-value="inativo" :disabled="!permissaoEditar" class="tw-sr-only tw-peer">
                                    <div :class="theme === 'dark' ? 'tw-w-10 tw-h-5 tw-bg-slate-700 tw-rounded-full tw-peer peer-checked:tw-bg-emerald-500' : 'tw-w-10 tw-h-5 tw-bg-gray-300 tw-rounded-full tw-peer peer-checked:tw-bg-emerald-500'" class="peer-checked:after:tw-translate-x-5 after:tw-content-[''] after:tw-absolute after:tw-top-[2px] after:tw-left-[2px] after:tw-bg-white after:tw-rounded-full after:tw-h-4 after:tw-w-4 after"></div>
                                </label>
                            </div>
                            <div class="tw-space-y-4">
                                <div v-for="(item, key) in [
                                    { label: 'Histerese Umidade', model: 'histerese_umidade', unit: '%', desc: 'Margem de segurança para variação da umidade' },
                                    { label: 'Espera pós Chuva', model: 'intervalo_espera_pos_chuva', unit: 'min', desc: 'Tempo de intervalo sem chuva antes de acionar' },
                                    { label: 'Partida Motores', model: 'intervalo_partida_motores', unit: 'min', desc: 'Intervalo entre acionamento de motores' }
                                    ]" :key="key" :class="theme === 'dark' ? 'tw-group tw-flex tw-items-center tw-justify-between tw-p-4 tw-bg-[#1a1d21] tw-rounded-2xl focus-within:tw-ring-2 focus-within:tw-ring-blue-500/20' : 'tw-group tw-flex tw-items-center tw-justify-between tw-p-4 tw-bg-white tw-rounded-2xl focus-within:tw-ring-2 focus-within:tw-ring-blue-500/20'">
                                    <div class="tw-space-y-0.5">
                                        <h4 :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-sm tw-font-bold tw-uppercase tw-tracking-tight">
                                            {{ item.label }}
                                        </h4>
                                        <p :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-text-xs tw-font-medium">
                                            {{ item.desc }}
                                        </p>
                                    </div>

                                    <div :class="theme === 'dark' ? 'tw-flex tw-items-baseline tw-gap-1.5 tw-bg-slate-800 tw-px-4 tw-py-2 tw-rounded-xl group-focus-within:tw-bg-blue-500/10' : 'tw-flex tw-items-baseline tw-gap-1.5 tw-bg-gray-300 tw-px-4 tw-py-2 tw-rounded-xl group-focus-within:tw-bg-blue-50'">
                                        <input 
                                            type="number" 
                                            v-model="parametros_configuracoes[item.model]" 
                                            :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-300 tw-text-black'" 
                                            class="tw-w-20 tw-text-right tw-text-xl tw-font-black tw-outline-none tw-appearance-none"
                                        >
                                        <span :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-text-lg tw-font-bold tw-select-none">
                                            {{ item.unit }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div v-if="permissaoEditar" class="tw-flex tw-gap-3 tw-justify-end tw-pb-4">
                        <button @click="resetParametros" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-200 tw-text-slate-700 hover:tw-bg-gray-300'" class="tw-px-5 tw-py-2 tw-text-sm tw-font-semibold tw-rounded-xl">
                            Descartar
                        </button>
                        <button 
                            @click="storeParametrosConfiguracoes"
                            :disabled="saveParametrosLoading"
                            :class="theme === 'dark' ? 'tw-bg-emerald-500 hover:tw-bg-emerald-600 focus:tw-ring-emerald-500/20' : 'tw-bg-emerald-600 hover:tw-bg-emerald-700 focus:tw-ring-emerald-100'"
                            class="tw-px-6 tw-py-2.5 tw-text-white tw-text-sm tw-font-bold tw-rounded-xl tw-shadow-sm focus:tw-ring-4 disabled:tw-opacity-50"
                        >
                            <span v-if="!saveParametrosLoading">Salvar Alterações</span>
                            <span v-else>Processando...</span>
                        </button>
                    </div>
                </div>
            </div>
        </main>
    </MainLayout>
</template>
<script>
import MainLayout from '@/components/layouts/v2/MainLayout.vue';
import LoaderPage from '@/components/ui/v2/LoaderPage.vue';
import { useToast } from 'vue-toastification';
import { mapState } from 'vuex';

export default {
    components: {
        MainLayout,
        LoaderPage
    },

    data() {
        return {
            items: [
                {"descricao": "Winckieel", "url": "/v1/unidades"},
                {"descricao": "Unidade", "url": "/v2/unidades/"+ this.$route.params.unidade},
            ],
            page: "Aeração",
            saveParametrosLoading: false,
            parametros_configuracoes: {
                "horario_ponta_inicio": null,
                "horario_ponta_termino": null,
                "horario_ponta": null,
                "aeracao_chuva": null,
                "aeracao_termometria": null,
                "intervalo_pos_chuva": null,
                "intervalo_espera_pos_chuva": null,
                "intervalo_partida_motores": null,
                "demanda": null,
                "aeracao_demanda_kw": null,
                "aeracao_custo_kw": null,
                "histerese_umidade": null
            },
            loadingPage: true,
            permissaoEditar: false
        }
    },

    computed: {
        ...mapState({
            theme: state => state.ui.theme,
        }),
        isTermocloud() {
            return String(this.$store.state.unidade.unidade?.tipo_produto || '').toLowerCase() === 'termocloud';
        },
    },
    async mounted() {
        this.toast = useToast();
        this.getParametrosConfiguracoes();
    },

    methods: {
        async getParametrosConfiguracoes() {
            try {
                const response = await this.$store.dispatch('unidade/getParametrosConfiguracoes', this.$route.params.unidade);
                await this.$store.dispatch("unidade/fetchUnidade", response.unidade_id);
                if (response) {
                    this.parametros_configuracoes = response;
                    this.permissaoEditar = this.$store.state.unidade.unidade.permissoes.parametrizacao_configuracoes_gerais !== 0;
                } 
            } catch (error) {
                console.error("Erro ao buscar os dados:", error);
                this.toast.error("Erro ao buscar os parâmetros");
            }
            this.loadingPage = false;
        },
        async storeParametrosConfiguracoes() {
            try{
                this.saveParametrosLoading = true;
                const unidade = this.$route.params.unidade;  
                const datas = this.parametros_configuracoes;
                datas['horario_ponta_inicio'] = datas['horario_ponta_inicio'].substring(0, 5);
                datas['horario_ponta_termino'] = datas['horario_ponta_termino'].substring(0, 5);
                const response = await this.$store.dispatch('unidade/storeParametrosConfiguracoes', {'unidadeId': unidade, 'data': datas });
                this.toast.info(this.isTermocloud ? "Parâmetros enviados ao TermoCloud, aguardando confirmação..." : "Dados enviados ao Painel TermoWeb, aguardando confirmação...", { timeout: 3900 });
                let messageId = response.data.message.original.message.message_id;
                setTimeout(async () => {
                    let msg = await this.$store.dispatch("message/fetchMessage", messageId);
                    if (msg.status !== 'processed') {
                        this.toast.error(`Parâmetros não processados pelo ${this.isTermocloud ? 'TermoCloud' : 'Painel TermoWeb'}.`);
                        this.saveParametrosLoading = false;
                    } else {
                        this.toast.success("Parâmetros atualizados com sucesso.");
                        this.saveParametrosLoading = false;
                    }
                }, 4000);
                this.parametros_configuracoes = response.data.parametrosConfiguracoes;
            } catch (error) {
                this.getParametrosConfiguracoes();
                this.saveParametrosLoading = false;
                this.toast.error("Erro ao atualizar parâmetros");
            }
        },
        resetParametros() {
            this.getParametrosConfiguracoes();
        }
    }
}
</script>

<style scoped>
.relogio-dark {
    color-scheme: light;
}
.relogio-dark::-webkit-calendar-picker-indicator {
    filter: invert(1);
    opacity: 0.8;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
}
</style>
